export function createLearningTaskCompletionKey(stageId: string, taskId: string): string {
  return `learning-task:${encodeURIComponent(stageId)}:${encodeURIComponent(taskId)}`
}

export function isLearningTaskCompleted(
  stageId: string,
  taskId: string,
  completedTasks: Record<string, boolean>,
): boolean {
  return Boolean(completedTasks[createLearningTaskCompletionKey(stageId, taskId)])
}

export function countCompletedTasksInNaturalMonth(
  taskCompletedAt: Record<string, string>,
  now = new Date(),
): number {
  return Object.values(taskCompletedAt).filter((completedAt) => {
    const date = new Date(completedAt)
    return Number.isFinite(date.getTime())
      && date.getFullYear() === now.getFullYear()
      && date.getMonth() === now.getMonth()
  }).length
}
